import { Component } from '@angular/core';

@Component({
  selector: 'acarc-home',
  template: `<dashboard [isPublic]="true"></dashboard>`
})
export class HomeComponent {}
// console.log(`%cHomeComponent::ngOnInit`, 'background:yellow');
